import { createSelector } from 'reselect';

export const selectedProvisionalClaim = (state: any) => {
  return state.get('provisionalClaim');
};

const makeSelectProvisionalClaim = () =>
  createSelector(selectedProvisionalClaim, provisionalClaim => {
    if (provisionalClaim && provisionalClaim.get('provisionalClaims')) {
      return provisionalClaim.get('provisionalClaims').toJS();
    }
    return [];
  });
export { makeSelectProvisionalClaim };
